import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import {
  IDealerContractConfirmRequest,
  IDealerContractConfirmResponse,
  IDealerContractDocumentUploadRequest,
  IDealerContractInfoRequest,
  IDealerContractSaveInfoResponse,
} from '../commonModels/dealerContractModels'

/** Bilgi formunu kaydeder ve sözleşme PDF'ini üretir. */
export class DealerContractSaveInfoApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/contract/save-info',
      requesterInfo,
    })
  }

  public async saveInfo(request: IDealerContractInfoRequest): Promise<IDealerContractSaveInfoResponse> {
    return await this.postAsync<IDealerContractSaveInfoResponse>(request)
  }
}

/** İmza Sirküsü ve Vergi Levhası belgelerini yükler. */
export class DealerContractUploadDocumentsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/contract/upload-documents',
      requesterInfo,
    })
  }

  public async uploadDocuments(request: IDealerContractDocumentUploadRequest): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}

/** Sözleşme onayı için SMS doğrulama kodu gönderir. Sunucuda 5 dakika tekrar kilidi var. */
export class DealerContractSendSmsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/contract/send-sms',
      requesterInfo,
    })
  }

  public async sendSms(): Promise<string> {
    return await this.postAsync<string>({})
  }
}

/** SMS kodunu doğrulayıp sözleşmeyi onaylar. */
export class DealerContractConfirmApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/contract/confirm',
      requesterInfo,
    })
  }

  public async confirm(request: IDealerContractConfirmRequest): Promise<IDealerContractConfirmResponse> {
    return await this.postAsync<IDealerContractConfirmResponse>(request)
  }
}

/**
 * Sözleşme adımından bilgi formuna dönmek için. Kayıt "düzenleniyor" işaretlenir,
 * sözleşme onayı düşürülür; admin bu kaydı bayi tamamlayana kadar onaylayamaz.
 */
export class DealerContractReopenApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/contract/reopen',
      requesterInfo,
    })
  }

  public async reopen(): Promise<boolean> {
    return await this.postAsync<boolean>({})
  }
}
